(() => {
  const root = window.FobLocks?.root || '/';
  const route = (path) => `${root}${path}`.replace(/\/+/g, '/');
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const status = document.querySelector('[data-cart-status]');
  const money = (cents, currency = 'USD') => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  // How many pouches a line item holds, read from the product title.
  const pouchesIn = (title) => (/4[\s-]?pack/i.test(title || '') ? 4 : 2);

  // ---------- cart drawer ----------
  function openCart() {
    if (!drawer || !overlay) return;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-is-open');
    drawer.querySelector('[data-cart-close]')?.focus();
  }

  function closeCart() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('cart-is-open');
  }

  function renderCart(cart) {
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    const empty = cart.item_count === 0;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = empty; });
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-label', `Open cart, ${cart.item_count} items`));
    document.querySelectorAll('[data-cart-subtotal], [data-cart-total]').forEach((node) => { node.textContent = money(cart.total_price, cart.currency); });
    document.querySelectorAll('[data-cart-checkout]').forEach((button) => { button.disabled = empty; });
    drawer?.setAttribute('data-cart-empty', String(empty));

    if (empty) {
      items.innerHTML = `<p class="cart-empty">Your cart is empty.<br><a href="${escapeHtml(root)}#buy">Start shopping &uarr;</a></p>`;
      return;
    }

    let pouchTotal = 0;
    const lines = cart.items.map((item) => {
      const each = pouchesIn(item.product_title);
      const linePouches = each * item.quantity;
      pouchTotal += linePouches;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` &middot; ${escapeHtml(item.variant_title)}` : '';
      const image = item.image ? `<img class="drawer-item__image" src="${escapeHtml(item.image)}" width="72" height="72" loading="lazy" alt="${escapeHtml(item.product_title)}">` : '';
      return `<div class="drawer-item">${image}<div class="drawer-item__body">` +
        `<div class="drawer-item__top"><span>${escapeHtml(item.product_title)}${variant}</span><span>${money(item.final_line_price, cart.currency)}</span></div>` +
        `<span class="drawer-item__meta">${linePouches} pouches total &middot; ${money(item.final_price / each, cart.currency)} per pouch</span>` +
        `<div class="drawer-item__controls">` +
        `<button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease ${escapeHtml(item.product_title)} quantity">&minus;</button>` +
        `<span>${item.quantity}</span>` +
        `<button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase ${escapeHtml(item.product_title)} quantity">+</button>` +
        `<button class="drawer-item__remove" type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0">Remove</button>` +
        `</div></div></div>`;
    }).join('');

    const total = money(cart.total_price, cart.currency);
    items.innerHTML = lines +
      `<div class="cart-summary" data-cart-summary>` +
      `<div class="cart-summary__row"><span>Subtotal &middot; <span data-cart-pouches>${pouchTotal}</span> pouches</span><b data-cart-subtotal>${total}</b></div>` +
      `<div class="cart-summary__row"><span>Shipping (US)</span><span class="free">FREE</span></div>` +
      `<div class="cart-summary__row"><span>Sales tax</span><span class="note">Added at checkout only where your state requires it</span></div>` +
      `<div class="cart-summary__row cart-summary__total"><span>Total before tax</span><span data-cart-total>${total}</span></div>` +
      `</div>` +
      `<div class="cart-promise">` +
      `<span>&#128666; <strong>Free standard US shipping</strong> &mdash; delivery estimate shown at checkout, tracked</span>` +
      `<span>&#9989; <strong>30-day money-back guarantee</strong> &mdash; doesn&rsquo;t block? Full refund, keep the pouch. <a href="#guarantee" data-cart-close>Terms</a></span>` +
      `</div>`;
  }

  async function getCart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load the cart.');
    return response.json();
  }

  async function changeCart(key, quantity) {
    const response = await fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Could not update the cart.');
    renderCart(data);
  }

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) { openCart(); return; }
    if (event.target.closest('[data-cart-close]') || event.target.matches('[data-cart-overlay]')) { closeCart(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      if (status) status.textContent = '';
      try { await changeCart(change.dataset.key, Number(change.dataset.quantity)); }
      catch (error) { if (status) status.textContent = error.message; change.disabled = false; }
    }
  });

  // ---------- add to cart / buy now ----------
  const setBusy = (button, busy) => {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    if (button.dataset.busyLabel) {
      if (busy) { button.dataset.idleLabel = button.innerHTML; button.innerHTML = button.dataset.busyLabel; }
      else if (button.dataset.idleLabel) button.innerHTML = button.dataset.idleLabel;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.js-add-to-cart');
    if (!form) return;
    if (event.submitter && !event.submitter.matches('[data-ajax-add]')) return;
    event.preventDefault();
    const submit = event.submitter || form.querySelector('[data-ajax-add]');
    const buyNow = submit?.hasAttribute('data-buy-now');
    const inlineError = form.querySelector('[data-buy-error]');
    if (inlineError) inlineError.textContent = '';
    if (status) status.textContent = '';
    setBusy(submit, true);
    let redirecting = false;
    try {
      const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not add this item.');
      // "Buy it now" skips the drawer and goes straight to checkout.
      if (buyNow) { redirecting = true; window.location.href = route('checkout'); return; }
      renderCart(await getCart());
      openCart();
    } catch (error) {
      if (buyNow && inlineError) inlineError.textContent = `${error.message} Please try again or email support@foblocks.com.`;
      else { if (status) status.textContent = error.message; openCart(); }
    } finally {
      // Stay "Adding…" only while the checkout redirect is in flight.
      if (!redirecting) setBusy(submit, false);
    }
  });

  // ---------- gallery ----------
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      const index = thumb.dataset.galleryThumb;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumb));
      gallery.querySelectorAll('[data-gallery-image]').forEach((image) => image.classList.toggle('is-active', image.dataset.galleryImage === index));
    });
  });

  // ---------- bundle picker + quantity ----------
  // Prices are cents on the radios and scale with quantity, so the headline
  // always shows what you'd actually pay.
  const buyForm = document.querySelector('[data-buy-form]');
  if (buyForm) {
    const qtyInput = buyForm.querySelector('[data-qty-input]');
    const readQty = () => {
      const n = parseInt(qtyInput?.value, 10);
      return Number.isFinite(n) && n > 0 ? Math.min(n, 99) : 1;
    };

    const syncPack = () => {
      const chosen = buyForm.querySelector('input[name="id"]:checked');
      buyForm.querySelectorAll('.bundle__option').forEach((option) => option.classList.toggle('is-selected', option.contains(chosen)));
      if (!chosen) return;
      const qty = readQty();
      const unit = Number(chosen.dataset.packPrice) || 0;
      const pouches = Number(chosen.dataset.packPouches) || 2;
      const save = Number(chosen.dataset.packSave) || 0;

      document.querySelectorAll('[data-selected-price]').forEach((n) => { n.textContent = money(unit * qty); });
      document.querySelectorAll('[data-selected-name]').forEach((n) => { n.textContent = chosen.dataset.packName || ''; });
      document.querySelectorAll('[data-selected-pouches]').forEach((n) => { n.textContent = String(pouches * qty); });
      document.querySelectorAll('[data-selected-per]').forEach((n) => { n.textContent = money(unit / pouches); });
      document.querySelectorAll('[data-selected-save]').forEach((n) => { n.hidden = save <= 0; });
      document.querySelectorAll('[data-selected-save-amount]').forEach((n) => { n.textContent = money(save * qty); });
    };

    buyForm.addEventListener('change', (event) => { if (event.target.name === 'id' || event.target === qtyInput) syncPack(); });
    qtyInput?.addEventListener('input', syncPack);
    buyForm.addEventListener('click', (event) => {
      const step = event.target.closest('[data-qty-step]');
      if (!step || !qtyInput) return;
      qtyInput.value = String(Math.min(99, Math.max(1, readQty() + Number(step.dataset.qtyStep))));
      syncPack();
    });
    syncPack();
  }

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  // /cart has no page of its own -- forward straight to checkout.
  document.querySelector('[data-checkout-forward]')?.submit();

  // ---------- demo video ----------
  // The same clip is placed twice (under the gallery on desktop, beside the
  // pitch on mobile) and CSS shows one. Both ship preload="none" so the 13 MB
  // file is only fetched by the copy that is actually on screen; the observer
  // below starts it. Without JS the videos keep native controls and a poster.
  const videos = [...document.querySelectorAll('[data-sound-video]')];
  videos.forEach((video) => { video.removeAttribute('controls'); });

  const setSoundLabels = () => {
    document.querySelectorAll('[data-sound-toggle]').forEach((toggle) => {
      const video = toggle.closest('.video-frame')?.querySelector('[data-sound-video]');
      if (!video) return;
      toggle.hidden = false;
      toggle.textContent = video.muted ? '\u{1F507} Tap for sound' : '\u{1F50A} Sound on — tap to mute';
      toggle.setAttribute('aria-pressed', String(!video.muted));
    });
  };
  setSoundLabels();
  document.querySelectorAll('.video-frame').forEach((frame) => {
    frame.addEventListener('click', () => {
      const muted = !(videos[0]?.muted ?? true);
      // Sound is a page-wide choice: unmute (or mute) every copy of the clip.
      videos.forEach((video) => {
        video.muted = muted;
        if (!muted && video.paused && video.offsetParent !== null) { const started = video.play(); if (started) started.catch(() => {}); }
      });
      setSoundLabels();
    });
  });

  // A denied play() (hidden tab, Low Power Mode) fires "pause" just like a
  // user click would. Only a pause after real playback counts as the user's,
  // and a rejected play() never leaves the video marked as user-paused.
  const playVideo = (video) => {
    const started = video.play();
    if (started) started.catch(() => { delete video.dataset.userPaused; });
  };
  const onScreen = (el) => {
    if (el.offsetParent === null) return false;
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  };
  const autoVideos = [...document.querySelectorAll('[data-autoplay-video]')];
  const observers = [];

  autoVideos.forEach((video) => {
    video.pausedByScroll = false;
    video.hasPlayed = false;
    video.addEventListener('playing', () => { video.hasPlayed = true; });
    // Browsers pause background media when a tab is hidden; nobody clicked.
    video.addEventListener('pause', () => { if (!video.pausedByScroll && video.hasPlayed && !document.hidden) video.dataset.userPaused = 'true'; });
    video.addEventListener('play', () => { delete video.dataset.userPaused; });
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (video.paused && !video.dataset.userPaused) { video.pausedByScroll = false; playVideo(video); }
        } else if (!video.paused) {
          video.pausedByScroll = true;
          video.pause();
        }
      });
    }, { threshold: 0.2 });
    observer.observe(video);
    observers.push(observer); // held so it can't be collected
  });

  // Belt and braces for the first play: the observer can be late (or the tab
  // hidden) on load, so also start any on-screen copy directly.
  const kickVideos = () => autoVideos.forEach((video) => {
    if (video.paused && !video.dataset.userPaused && onScreen(video)) { video.pausedByScroll = false; playVideo(video); }
  });
  kickVideos();
  window.addEventListener('scroll', kickVideos, { passive: true });
  window.addEventListener('resize', kickVideos);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) kickVideos(); });

  // ---------- sticky mobile bar ----------
  const sticky = document.querySelector('[data-sticky-offer]');
  if (sticky) {
    const updateSticky = () => sticky.classList.toggle('is-visible', window.scrollY > 900 && window.innerWidth < 900);
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
  }

  // ---------- product page variant select ----------
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const container = select.closest('[data-product-section]');
      const price = container?.querySelector('[data-product-price]');
      const button = container?.querySelector('[data-product-submit]');
      if (price) price.textContent = option.dataset.price || '';
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
})();
